import { render, staticRenderFns } from "./MyUpLoad.vue?vue&type=template&id=5c6cb824&scoped=true"
import script from "./MyUpLoad.vue?vue&type=script&lang=js"
export * from "./MyUpLoad.vue?vue&type=script&lang=js"
import style0 from "./MyUpLoad.vue?vue&type=style&index=0&id=5c6cb824&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6cb824",
  null
  
)

export default component.exports